import { useNavigate, useParams } from 'react-router';

import { OneColumn } from 'components/page';
import { LojaMenu } from 'pages/cadastro/loja/components/form/LojaMenu';
import { usePermissionsContext } from 'context/PermissionsContext';
import { useLojaStepContext } from 'pages/cadastro/loja/contexts';

export function LojaFormComp() {
    const { id } = useParams();
    const { activeStep } = useLojaStepContext();
    const { hasPermission } = usePermissionsContext();
    const navigate = useNavigate();

    return (
        <OneColumn
            goBackButton
            title={id ? 'Editar Loja' : 'Inserir Loja'}
            titleAddon={<LojaMenu />}
            extraButtons={[
                {
                    title: 'Gerenciar Seções',
                    onClick: () => navigate(`/cadastro/secoes/${id}`),
                    visible: hasPermission(['SECAO_GERENCIAR']),
                },
            ]}
        >
            {activeStep.component}
        </OneColumn>
    );
}
